angular.module('core')
    .component('phoneNumberDisplay', {
        bindings: {
            value: '<',
            defaultCountry: '@?',
            subjectName: '<?',
            showTelLink: '<?',
            showCopyAction: '<?',
            showOptionsMenu: '<?'
        },
        templateUrl: 'app/utils/phone-input/phone-number-display.html',
        controller: function (PhoneNumberFormatter, SmsService) {
            this.$onInit = () => {
                this.defaultCountry = this.defaultCountry || 'pl'
                this.showTelLink = this.showTelLink !== false
                this.showCopyAction = this.showCopyAction !== false
                this.showOptionsMenu = this.showOptionsMenu !== false
            }

            this.$onChanges = () => {
                this.formattedValue = PhoneNumberFormatter.formatForDisplay(this.value, this.defaultCountry)
                let parsedCountry = PhoneNumberFormatter.getCountryForNumber(this.value, this.defaultCountry)
                let normalizedDefaultCountry = PhoneNumberFormatter.normalizeCountryCode(this.defaultCountry)
                this.showCountryFlag = !!parsedCountry && parsedCountry !== normalizedDefaultCountry
                this.displayCountryCode = parsedCountry ? parsedCountry.toLowerCase() : null
                this.isNumberValid = this.hasValue() && PhoneNumberFormatter.isValidNumber(this.value, this.defaultCountry)
                this.isNumberPossible = this.hasValue() && PhoneNumberFormatter.isPossibleNumber(this.value, this.defaultCountry)
                this.isNumberPossibleOnly = this.hasValue() && !this.isNumberValid && this.isNumberPossible
                this.isNumberInvalid = this.hasValue() && !this.isNumberValid && !this.isNumberPossible
            }

            this.hasValue = () => !!(this.value && String(this.value).trim())

            this.canShowOptions = () => this.showOptionsMenu === true
                && this.hasValue()
                && !!SmsService
                && typeof SmsService.sendMessageToPhone === 'function'

            this.sendSms = () => {
                if (this.canShowOptions()) {
                    SmsService.sendMessageToPhone(this.value, this.subjectName)
                }
            }
        }
    })
